// extracted by css-extract-rspack-plugin
export default {"switcher-container":"SubscriptionSettings-module__switcher-container--fDv03","switcherContainer":"SubscriptionSettings-module__switcher-container--fDv03"};